var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupe3577(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3577",
    "data-name": "Groupe 3577",
    transform: "translate(-276 -2611)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2530",
    "data-name": "Rectangle 2530",
    width: 61,
    height: 60,
    rx: 8,
    transform: "translate(276 2611)",
    fill: "#a99479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-people-outline",
    "data-name": "Icon material-people-outline",
    d: "M26.687,20.5a19.478,19.478,0,0,0-7.312,1.625A19.168,19.168,0,0,0,12.062,20.5C8.536,20.5,1.5,22.255,1.5,25.781V30.25H37.249V25.781C37.249,22.255,30.213,20.5,26.687,20.5Zm-6.5,7.312H3.937V25.781c0-.877,4.16-2.844,8.125-2.844s8.125,1.966,8.125,2.844Zm14.625,0H22.625V25.781A2.957,2.957,0,0,0,21.78,23.8a15.677,15.677,0,0,1,4.907-.861c3.965,0,8.125,1.966,8.125,2.844Zm-22.75-8.937a5.687,5.687,0,1,0-5.687-5.687A5.694,5.694,0,0,0,12.062,18.875Zm0-8.937a3.25,3.25,0,1,1-3.25,3.25A3.26,3.26,0,0,1,12.062,9.937Zm14.625,8.937A5.687,5.687,0,1,0,21,13.187,5.694,5.694,0,0,0,26.687,18.875Zm0-8.937a3.25,3.25,0,1,1-3.25,3.25A3.26,3.26,0,0,1,26.687,9.937Z",
    transform: "translate(287.5 2622.5)",
    fill: "#f0efea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe3577);
export default __webpack_public_path__ + "static/media/Groupe 3577.68df9fd04d75586569adcbea14ba5e52.svg";
export { ForwardRef as ReactComponent };